import React from 'react';
import { TextField, Grid, Typography, InputAdornment, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { useOutletContext } from 'react-router-dom';

const FinancialInfoStep = () => {
    const { formData, handleInputChange, errors } = useOutletContext();
    // This step will now write to the 'financial' part of the formData state
    const data = formData.financial || {};

    return (
        <>
            <Typography variant="h6" gutterBottom>Financial Information</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Please provide details about your household's financial situation. This information is confidential and used to assess financial need.
            </Typography>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        name="householdIncome"
                        label="Total Combined Household Income (Annual)"
                        type="number"
                        fullWidth
                        value={data.householdIncome || ''}
                        onChange={(e) => handleInputChange('financial', e)}
                        error={!!errors.householdIncome}
                        helperText={errors.householdIncome}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">R</InputAdornment>,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        name="dependents"
                        label="Number of Dependents in Household"
                        type="number"
                        fullWidth
                        value={data.dependents || ''}
                        onChange={(e) => handleInputChange('financial', e)}
                        error={!!errors.dependents}
                        helperText={errors.dependents}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth error={!!errors.fundingSource}>
                        <InputLabel>Primary Source of Current Funding</InputLabel>
                        <Select
                            name="fundingSource"
                            value={data.fundingSource || ''}
                            label="Primary Source of Current Funding"
                            onChange={(e) => handleInputChange('financial', e)}
                        >
                            <MenuItem value="Family">Family Contribution</MenuItem>
                            <MenuItem value="NSFAS">NSFAS</MenuItem>
                            <MenuItem value="OtherBursary">Other Bursary/Loan</MenuItem>
                            <MenuItem value="SelfFunded">Self-Funded (Savings/Work)</MenuItem>
                            <MenuItem value="None">No Current Funding</MenuItem>
                        </Select>
                        {errors.fundingSource && <FormHelperText>{errors.fundingSource}</FormHelperText>}
                    </FormControl>
                </Grid>
            </Grid>
        </>
    );
};

export default FinancialInfoStep;